import { useL10n } from '@uplift/hooks';
import { TextInput } from '@uplift/ui-v2';
import { useSettingsStyles } from '../../../styles';

export const ClientFacingEmailForm = () => {
  const l10n = useL10n();
  const { classes } = useSettingsStyles();

  return (
    <div className={classes.formGroup}>
      <TextInput
        label=""
        name="clientFacingEmail"
        helperText={l10n.providerSettings.emailDisplayedToYourClients}
        errorTextFirst
      />
    </div>
  );
};
